import { useLoadingAction } from 'src/hooks/use-actions';

import { apiCreate, apiUpdate, apiRemove, apiBillNo } from './data-form';

const useForms = () => {

  const insertItem = (payload, onSuccess, onError) => useLoadingAction(apiCreate, payload, onSuccess, onError);
  const updateItem = (payload, onSuccess, onError) => useLoadingAction(apiUpdate, payload, onSuccess, onError);
  const removeItem = (payload, onSuccess, onError) => useLoadingAction(apiRemove, payload, onSuccess, onError);
  const updateBillNo = (payload, onSuccess, onError) => useLoadingAction(apiBillNo, payload, onSuccess, onError);

  return {
    insertItem,
    updateItem,
    removeItem,
    updateBillNo
  };
};

export default useForms;
